import AbstractService from 'src/services/AbstractService';
import config from 'src/lib/config';
import { ServiceError } from 'src/lib/errors';
import { logServiceError } from 'src/utils/logger';

class NotificationChannelService extends AbstractService {
    constructor() {
        super(config.services.config);
    }

    public async getNotificationChannel(id: number): Promise<Services.NotificationChannels.NotificationChannel> {
        const requestUrl = `api/v3/NotificationChannels/${id}`;

        try {
            const response = await this.api.get<Services.NotificationChannels.NotificationChannel>(requestUrl, {
                params: {
                    requestor: config.appName,
                },
            });

            return response.data;
        } catch (e: any) {
            const error = new ServiceError(e);

            logServiceError(error);
            throw error;
        }
    }

    public async getPagableNotificationChannels(
        notificationChannelSearch: Services.NotificationChannels.NotificationChannelSearch,
    ): Promise<Services.NotificationChannels.NotificationChannel[]> {
        const requestUrl = 'api/v3/NotificationChannels';

        try {
            const response = await this.api.get<Services.NotificationChannels.NotificationChannel[]>(requestUrl, {
                params: {
                    limit: notificationChannelSearch.limit ? notificationChannelSearch.limit : 10000,
                    ...notificationChannelSearch,
                    requestor: config.appName,
                },
            });

            return response.data;
        } catch (e: any) {
            const error = new ServiceError(e);

            logServiceError(error);
            throw error;
        }
    }

    public async createNotificationChannel(
        notificationChannel: Services.NotificationChannels.CreateNotificationChannel,
        bearerToken: string,
    ): Promise<Services.NotificationChannels.NotificationChannel> {
        const requestUrl = 'api/v3/NotificationChannels';

        try {
            const response = await this.api.post(
                requestUrl,
                notificationChannel,
                {
                    params: {
                        requestor: config.appName,
                    },
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                    },
                },
            );

            return response.data;
        } catch (e: any) {
            const error = new ServiceError(e);

            logServiceError(error);
            throw error;
        }
    }

    public async updateNotificationChannel(
        id: number,
        notificationChannel: Services.NotificationChannels.NotificationChannel,
        bearerToken: string,
    ): Promise<Services.NotificationChannels.NotificationChannel> {
        const requestUrl = `api/v3/NotificationChannels/${id}`;

        try {
            const response = await this.api.put(
                requestUrl,
                notificationChannel,
                {
                    params: {
                        requestor: config.appName,
                    },
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                    },
                },
            );

            return response.data;
        } catch (e: any) {
            const error = new ServiceError(e);

            logServiceError(error);
            throw error;
        }
    }

    public async deleteNotificationChannel(
        id: number,
        bearerToken: string,
    ): Promise<void> {
        const requestUrl = `api/v3/NotificationChannels/${id}`;

        try {
            return await this.api.put(
                requestUrl,
                {
                    params: {
                        requestor: config.appName,
                    },
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                    },
                },
            );
        } catch (e: any) {
            const error = new ServiceError(e);

            logServiceError(error);
            throw error;
        }
    }
}

export default new NotificationChannelService();
